import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import LogoProcessor from '@/components/LogoProcessor';

const LogoProcessingPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background p-4">
      <div className="max-w-4xl mx-auto">
        <div className="mb-6">
          <Button
            variant="outline"
            onClick={() => navigate('/')}
            className="flex items-center space-x-2"
          >
            <ArrowLeft className="w-4 h-4" />
            <span>Back to Home</span>
          </Button>
        </div>
        
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-primary mb-2">Logo Processing</h1>
          <p className="text-muted-foreground">
            Remove the background from your CareKonnect logo
          </p>
        </div>

        <LogoProcessor />
      </div>
    </div>
  );
};

export default LogoProcessingPage;